module.exports = __webpack_public_path__ + "img/6.375d445e.png";